var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelationship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8346 5.83333C10.8346 7.67428 9.34222 9.16667 7.5013 9.16667C5.66035 9.16667 4.16797 7.67428 4.16797 5.83333C4.16797 3.99238 5.66035 2.5 7.5013 2.5C9.34222 2.5 10.8346 3.99238 10.8346 5.83333Z",
    stroke: "#757575",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.16667C14.3409 9.16667 15.8333 7.67428 15.8333 5.83333C15.8333 3.99238 14.3409 2.5 12.5 2.5",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16797 11.6665H5.83464C3.53345 11.6665 1.66797 13.532 1.66797 15.8332C1.66797 16.7537 2.41416 17.4998 3.33464 17.4998H11.668C12.5885 17.4998 13.3346 16.7537 13.3346 15.8332C13.3346 13.532 11.4691 11.6665 9.16797 11.6665Z",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.168 11.6665C16.4691 11.6665 18.3346 13.532 18.3346 15.8332C18.3346 16.7537 17.5885 17.4998 16.668 17.4998H15.418",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelationship);
export default __webpack_public_path__ + "static/media/relationship.8028a08e8153a8678fd4339defcffa94.svg";
export { ForwardRef as ReactComponent };